import { Data, Result, Url } from '@blade/std-lib'

import * as KnownSocialPlatformMatchType from './known-scial-paltform-match-type'
import {
  BlueskyKnownSocialPlatformResource,
  FacebookKnownSocialPlatformResource,
  GithubKnownSocialPlatformResource,
  InstagramKnownSocialPlatformResource,
  RedditKnownSocialPlatformResource,
  SubstackKnownSocialPlatformResource,
  TelegramKnownSocialPlatformResource,
  TiktokKnownSocialPlatformResource,
  TwitchKnownSocialPlatformResource,
  PinterestKnownSocialPlatformResource,
  WikiKnownSocialPlatformResource,
  YoutubeKnownSocialPlatformResource,
} from './known-social-platform-resource'
import { XKnownSocialPlatformResource } from './known-social-platform-resource'

const KnownSocialPlatformTag = {
  Youtube: 'youtube',
  Tiktok: 'tiktok',
  X: 'x',
  Instagram: 'instagram',
  Facebook: 'facebook',
  Discord: 'discord',
  Telegram: 'telegram',
  LinkedIn: 'linkedin',
  Github: 'github',
  Reddit: 'reddit',
  Medium: 'medium',
  Substack: 'substack',
  Twitch: 'twitch',
  Pinterest: 'pinterest',
  Threads: 'threads',
  Whatsapp: 'whatsapp',
  Wiki: 'wiki',
  Bluesky: 'bluesky',
  Website: 'website',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type KnownSocialPlatformTag =
  (typeof KnownSocialPlatformTag)[keyof typeof KnownSocialPlatformTag]

export class YoutubeKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Youtube,
)<{
  url: string
}> {
  //www.youtube.com/watch?v=wBrqZ_2cDkA
  static readonly browserUrlDomain = 'youtube.com'
  //youtu.be/wBrqZ_2cDkA?si=Y6-51Xq45fcnh2my
  static readonly shareUrlDomain = 'youtu.be'
  static readonly hostnameRoots = [
    this.browserUrlDomain,
    this.shareUrlDomain,
  ] as const
  readonly label = 'YouTube'
}

export class TiktokKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Tiktok,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['tiktok.com'] as const
  readonly label = 'TikTok'
}

export class BlueskyKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Bluesky,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['bsky.app'] as const
  readonly label = 'Bluesky'
}

export class XKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.X,
)<{
  url: string
}> {
  static readonly hostnameRoots = [
    new KnownSocialPlatformMatchType.StrictMatchType({ value: 'twitter.com' }),
    new KnownSocialPlatformMatchType.StrictMatchType({ value: 'x.com' }),
  ] as const
  readonly label = 'X'
}

export class InstagramKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Instagram,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['instagram.com'] as const
  readonly label = 'Instagram'
}

export class FacebookKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Facebook,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['facebook.com', 'fb.com', 'fb.me'] as const
  readonly label = 'Facebook'
}

export class DiscordKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Discord,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['discord.com', 'discord.gg'] as const
  readonly label = 'Discord'
}

export class TelegramKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Telegram,
)<{
  url: string
}> {
  static readonly hostnameRoots = [
    'telegram.me',
    'telegram.dog',
    't.me',
    'telegram.org',
  ] as const
  readonly label = 'Telegram'
}

export class LinkedInKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.LinkedIn,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['linkedin.com'] as const
  readonly label = 'LinkedIn'
}

export class GithubKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Github,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['github.com', 'github.io'] as const
  readonly label = 'GitHub'
}

export class RedditKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Reddit,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['reddit.com', 'redd.it'] as const
  readonly label = 'Reddit'
}

export class MediumKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Medium,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['medium.com'] as const
  readonly label = 'Medium'
}

export class SubstackKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Substack,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['substack.com'] as const
  readonly label = 'Substack'
}

export class TwitchKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Twitch,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['twitch.tv'] as const
  readonly label = 'Twitch'
}

export class PinterestKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Pinterest,
)<{
  url: string
}> {
  static readonly hostnameRoots = [
    'pinterest.com',
    'pinterest.co.uk',
    'pin.it',
  ] as const
  readonly label = 'Pinterest'
}

export class ThreadsKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Threads,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['threads.net'] as const
  readonly label = 'Threads'
}

export class WhatsappKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Whatsapp,
)<{
  url: string
}> {
  static readonly hostnameRoots = ['whatsapp.com', 'wa.me'] as const
  readonly label = 'WhatsApp'
}

export class WikiKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Wiki,
)<{
  url: string
}> {
  static readonly hostnameRoots = [
    'wikipedia.org',
    'wiktionary.org',
    'wikiquote.org',
  ] as const
  readonly label = 'Wikipedia'
}

export class WebsiteKnownSocialPlatform extends Data.TaggedClass(
  KnownSocialPlatformTag.Website,
)<{
  url: string
}> {
  static readonly hostnameRoots = [] as const
  readonly label = 'Website'
  get domain(): string | undefined {
    const urlParseResult = Url.fromString(this.url)

    if (Result.isFailure(urlParseResult)) {
      return undefined
    }

    return urlParseResult.success.hostname
  }
}

export type KnownSocialPlatform =
  | WebsiteKnownSocialPlatform
  | YoutubeKnownSocialPlatform
  | TiktokKnownSocialPlatform
  | BlueskyKnownSocialPlatform
  | XKnownSocialPlatform
  | InstagramKnownSocialPlatform
  | FacebookKnownSocialPlatform
  | DiscordKnownSocialPlatform
  | TelegramKnownSocialPlatform
  | LinkedInKnownSocialPlatform
  | GithubKnownSocialPlatform
  | RedditKnownSocialPlatform
  | MediumKnownSocialPlatform
  | SubstackKnownSocialPlatform
  | TwitchKnownSocialPlatform
  | PinterestKnownSocialPlatform
  | ThreadsKnownSocialPlatform
  | WhatsappKnownSocialPlatform
  | WikiKnownSocialPlatform

export const match = Data.matchFor<KnownSocialPlatform>()

export const resource = match({
  youtube: (platform) =>
    YoutubeKnownSocialPlatformResource.fromString(platform.url),
  tiktok: (platform) =>
    TiktokKnownSocialPlatformResource.fromString(platform.url),
  instagram: (platform) =>
    InstagramKnownSocialPlatformResource.fromString(platform.url),
  x: (platform) => XKnownSocialPlatformResource.fromString(platform.url),
  facebook: (platform) =>
    FacebookKnownSocialPlatformResource.fromString(platform.url),
  discord: () => undefined,
  telegram: (platform) =>
    TelegramKnownSocialPlatformResource.fromString(platform.url),
  linkedin: () => undefined,
  github: (platform) =>
    GithubKnownSocialPlatformResource.fromString(platform.url),
  reddit: (platform) =>
    RedditKnownSocialPlatformResource.fromString(platform.url),
  medium: () => undefined,
  substack: (platform) =>
    SubstackKnownSocialPlatformResource.fromString(platform.url),
  twitch: (platform) =>
    TwitchKnownSocialPlatformResource.fromString(platform.url),
  pinterest: (platform) =>
    PinterestKnownSocialPlatformResource.fromString(platform.url),
  threads: () => undefined,
  whatsapp: () => undefined,
  wiki: (platform) => WikiKnownSocialPlatformResource.fromString(platform.url),
  website: () => undefined,
  bluesky: (platform) =>
    BlueskyKnownSocialPlatformResource.fromString(platform.url),
})

export const domain = (platform: KnownSocialPlatform): string | undefined => {
  const urlParseResult = Url.fromString(platform.url)
  if (Result.isFailure(urlParseResult)) {
    return undefined
  }

  return urlParseResult.success.hostname
}

interface KnownSocialPlatformCtor {
  new (props: { url: string }): KnownSocialPlatform
  hostnameRoots: ReadonlyArray<KnownSocialPlatformMatchType.KnownSocialPlatformMatchType>
}

const KNOWN_SOCIAL_PLATFORM_CTORS: ReadonlyArray<KnownSocialPlatformCtor> = [
  YoutubeKnownSocialPlatform,
  TiktokKnownSocialPlatform,
  BlueskyKnownSocialPlatform,
  XKnownSocialPlatform,
  InstagramKnownSocialPlatform,
  FacebookKnownSocialPlatform,
  DiscordKnownSocialPlatform,
  TelegramKnownSocialPlatform,
  LinkedInKnownSocialPlatform,
  GithubKnownSocialPlatform,
  RedditKnownSocialPlatform,
  MediumKnownSocialPlatform,
  SubstackKnownSocialPlatform,
  TwitchKnownSocialPlatform,
  PinterestKnownSocialPlatform,
  ThreadsKnownSocialPlatform,
  WhatsappKnownSocialPlatform,
  WikiKnownSocialPlatform,
]

export const xFromString = (url: string): XKnownSocialPlatform | undefined => {
  const host = websiteUrlHostname(url)
  if (!host) {
    return undefined
  }
  if (hostMatch(host, XKnownSocialPlatform.hostnameRoots)) {
    return new XKnownSocialPlatform({ url })
  }
}

export const fromString = (url: string): KnownSocialPlatform | undefined => {
  const host = websiteUrlHostname(url)
  if (!host) {
    return undefined
  }

  for (const Platform of KNOWN_SOCIAL_PLATFORM_CTORS) {
    if (hostMatch(host, Platform.hostnameRoots)) {
      return new Platform({ url })
    }
  }
  return new WebsiteKnownSocialPlatform({ url })
}

const websiteUrlHostname = (rawUrl: string): string | undefined => {
  const trimmed = rawUrl.trim()
  if (!trimmed) {
    return undefined
  }
  const href = /^[a-z][\d+.a-z-]*:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`
  try {
    return new URL(href).hostname.toLowerCase()
  } catch {
    return undefined
  }
}

const hostMatch = (
  hostname: string,
  roots: ReadonlyArray<KnownSocialPlatformMatchType.KnownSocialPlatformMatchType>,
): boolean =>
  roots.some((root) => {
    if (root instanceof KnownSocialPlatformMatchType.StrictMatchType) {
      return hostname === root.value
    }
    return hostname === root || hostname.endsWith(`.${root}`)
  })
